// extracted by mini-css-extract-plugin
export var actuItem = "listActus-module--actu-item--53773";
export var actuItemsContainer = "listActus-module--actu-items-container--87b46";
export var actuTaxoContainer = "listActus-module--actu-taxo-container--e3b16";
export var actualiteCategorie = "listActus-module--actualite-categorie--c94ba";
export var actualiteDate = "listActus-module--actualite-date--0240a";
export var actualiteInfos = "listActus-module--actualite-infos--56f06";
export var actualiteResume = "listActus-module--actualite-resume--1f54c";
export var actualiteTitle = "listActus-module--actualite-title--b94a2";
export var actusFilters = "listActus-module--actus-filters--a1205";
export var disabled = "listActus-module--disabled--f0534";
export var listActualitesContainer = "listActus-module--list-actualites-container--4cb76";
export var listActus = "listActus-module--list-actus--fc6c3";
export var vocalizedUpdate = "listActus-module--vocalized-update--7580e";
export var zoneActualitesLibreBas = "listActus-module--zone-actualites-libre-bas--2bb98";
export var zoneActualitesLibreHaut = "listActus-module--zone-actualites-libre-haut--80dd7";